module.exports = __webpack_public_path__ + "static/fsd-logo-d826e9beae8766c02a27a2633123fa04.png";